import React, { createContext, useContext, useState } from 'react';

// Create the context
const NewEmergencyContext = createContext();

// Create a custom hook to use the context
export function useNewEmergency() {
  return useContext(NewEmergencyContext);
}

// Create the context provider component
export function NewEmergencyProvider({ children }) {
  const [newEmergencyNotification, setNewEmergencyNotification] = useState(1);

  const handleNewEmergencyNotification = (newvalue) => {
    setNewEmergencyNotification(newvalue);
  };

  const value = {
    newEmergencyNotification,
    handleNewEmergencyNotification,
  };

  return (
    <NewEmergencyContext.Provider value={value}>
      {children}
    </NewEmergencyContext.Provider>
  );
}
